/* PetalHush P-053: reviews section behaviour (sections/ph-reviews.liquid).
   - Read more: a long review is clamped to 6 lines only when it overflows; the button toggles it (aria-expanded).
   - Show more: cards after the first N (data-per) start hidden; each click shows the next N and moves focus to the
     first new card. Without JS every card and every full text shows.
   - Photo: opens in a native <dialog> (Esc, Close and a backdrop click close it, focus returns). Without <dialog>
     support (or JS) the link opens the image itself.
   Re-runs on theme-editor section reloads. Respects prefers-reduced-motion (no smooth scroll). */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.phReady) return;
    root.dataset.phReady = '1';
    root.classList.add('is-js');
    var per = parseInt(root.dataset.per, 10) || 6;

    /* read more */
    Array.prototype.forEach.call(root.querySelectorAll('[data-ph-rvw-body]'), function (body) {
      var btn = body.parentNode.querySelector('[data-ph-rvw-rm]');
      if (!btn) return;
      body.classList.add('is-clamp');
      function check() {
        if (btn.getAttribute('aria-expanded') === 'true') return;
        var over = body.scrollHeight > body.clientHeight + 1;
        btn.hidden = !over;
        if (!over) body.classList.remove('is-clamp'); else body.classList.add('is-clamp');
      }
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', String(open));
        body.classList.toggle('is-clamp', !open);
        btn.textContent = open ? (root.dataset.less || 'Show less') : (root.dataset.more || 'Read more');
      });
      body._phCheck = check;
    });
    function checkAll() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-ph-rvw-body]'), function (b) {
        if (b._phCheck && b.offsetParent !== null) b._phCheck();
      });
    }

    /* show more */
    var more = root.querySelector('[data-ph-rvw-more]'), live = root.querySelector('[data-ph-rvw-live]');
    function hiddenCards() { return Array.prototype.filter.call(root.querySelectorAll('[data-ph-extra]'), function (c) { return !c.classList.contains('is-shown'); }); }
    if (more) {
      more.hidden = hiddenCards().length === 0;
      more.addEventListener('click', function () {
        if (more.dataset.fewer === '1') {   /* "Show fewer": hide the extra cards again and go back to the list head */
          Array.prototype.forEach.call(root.querySelectorAll('[data-ph-extra]'), function (c) { c.classList.remove('is-shown'); });
          more.dataset.fewer = ''; more.textContent = root.dataset.morel || 'Show more reviews';
          var h = root.querySelector('h2'); if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
          return;
        }
        var next = hiddenCards().slice(0, per);
        next.forEach(function (c) { c.classList.add('is-shown'); });
        checkAll();
        if (next[0]) {
          var art = next[0].querySelector('article');
          if (art) { art.setAttribute('tabindex', '-1'); art.focus({ preventScroll: false }); }
        }
        if (live) live.textContent = (root.dataset.shown || '{n} more reviews shown.').replace('{n}', next.length);
        if (hiddenCards().length === 0) {
          if (root.dataset.fewer) { more.dataset.fewer = '1'; more.textContent = root.dataset.fewer; } else more.hidden = true;
        }
      });
    }

    /* photo dialog */
    var dlg = root.querySelector('[data-ph-rvw-dlg]'), dimg = dlg && dlg.querySelector('[data-ph-rvw-dlg-img]'), opener = null;
    if (dlg && typeof dlg.showModal === 'function') {
      root.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('[data-ph-rvw-photo]');
        if (!a || !root.contains(a)) return;
        e.preventDefault();
        opener = a;
        dimg.src = a.getAttribute('href');
        dimg.alt = a.dataset.alt || '';
        dlg.showModal();
      });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('close', function () { if (opener) opener.focus(); });
    }

    checkAll();
    if ('ResizeObserver' in window) {
      var t = null;
      new ResizeObserver(function () { clearTimeout(t); t = setTimeout(checkAll, 120); }).observe(root);
    }
  }
  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ph-rvw]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
